'use strict';

import { ajaxWrapNew, ResponseDispatcher } from './ajaxWrapNew.js';
import { urlSafe } from './urlTools.js';
import { setResetErrorFlds } from './forms.js';


function secondsToTime( inp ) {
    let m, s;
    m = Math.floor( inp / 60 );
    s = inp - m * 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
}

function initCounterTimer( counter, step, done ) {
    let timer;

    if (typeof step != 'function') step = function() {};
    if (typeof done != 'function') done = function() {};

    timer = setInterval(function(){
        counter--;

        if (counter < 0) {
            clearInterval( timer );


            done();
            return;
        }

        step( counter, timer );
    }, 1000);

    return timer;
}


export function loadRegister() {

    let nextSecurity = false;
    let resetElementTimer = function() {
        let timer, counter,
            self = this;

        counter = parseInt( $( self ).data('timer-seconds') );
        if (isNaN(counter) || counter <= 0) {
            return;
        }

        $( '.notsendagain' ).toggle( true );
        $( '.sendagain' ).toggle( false );

        $( '.custom-switch-notsendagain' ).trigger( 'jq-custom-switch', ['.custom-switch-notsendagain'] );

        initCounterTimer( counter, function( counter ) {
                $( self ).data('timer-seconds', counter);
                $( self ).text( secondsToTime( counter ) );
            }, function() {
                if (nextSecurity && !$('.existsSecurity').length) {
                    //window.location.reload();
                    urlSafe.reload();
                }

                $( '.notsendagain' ).toggle( false );
                $( '.sendagain' ).toggle( true );

                $( '.custom-switch-sendagain' ).trigger( 'jq-custom-switch', ['.custom-switch-sendagain'] );
            });
    };

    $( '.active-timer' ).each(function(){
        resetElementTimer.call( this );
    });

    $( '.pwsent' ).on('click', function( event ) {
        event.preventDefault();
    });

    $( '.sendagain' ).on('click', function( event ) {
        event.preventDefault();

        ajaxWrapNew({
            type: 'POST',
            data: {
                'frm-action': 'resend',
                'ajax': 1,
                'code': $('[name="code"]').length ? $('[name="code"]').val() : ''
            },
            success: function( data ) {
                try {
                    if (data.ok) {
                        $( '.active-timer' )
                            .data('timer-seconds', data.timerSeconds)
                            .text( secondsToTime( data.timerSeconds ) )
                            .each(function() {
                                resetElementTimer.call( this );
                            });

                        if (data.security) {
                            nextSecurity = true;
                        }

                        if (data.securityRefresh) {
                            $( '.codeRefresh' ).triggerHandler('click');
                        }

                        ResponseDispatcher.handle(data);
                    } else {
                        ResponseDispatcher.handle(data);

                        if (data.code) {
                            $( '.existsSecurity' ).addClass('error');
                            setResetErrorFlds('.frm-register', ['code']);
                        } else {
                            //window.location.reload();
                            urlSafe.reload();
                        }
                    }

                    if (data.securityRefresh) {
                        $( '.codeRefresh' ).triggerHandler('click');
                    }
                } catch(e) {

                }
            },
            dataType : 'json'
        });
    });
}